import { createSelector } from 'reselect';
import { getHasThemePresetsAccessScope } from './authSelectors';
import { getThemePath } from './themeSelectors';
import { getActiveThemePresetId } from './themeSettingsSelectors';
import { getIsPresetPanelOpen } from './appSelectors';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { PRESET_TYPES } from '../constants/Presets';
export const getHasThemePresetsAccess = (state, props) => {
  const isScopedForPresets = getHasThemePresetsAccessScope(state);
  const themePath = getThemePath(state) || (props === null || props === void 0 ? void 0 : props.themePath);
  return isScopedForPresets && themePath === '@hubspot/elevate' // TODO: remove this once other themes support presets
  ;
};
export const getPresetsById = state => state.presets.presetsById;
export const getPresetById = (state, id) => {
  return getPresetsById(state)[id];
};
export const getPresetsRequestStatus = state => state.presets.requestStatus;
export const getFetchActiveThemePresetBufferRequestStatus = state => state.presets.fetchActiveThemePresetBufferRequestStatus;
export const getThemePresetIdToPreview = state => {
  var _state$presets;
  return (_state$presets = state.presets) === null || _state$presets === void 0 ? void 0 : _state$presets.selectedThemePresetId;
};
export const getSelectedThemePresetId = state => {
  const isPresetPanelOpen = getIsPresetPanelOpen(state);
  const activeThemePresetId = getActiveThemePresetId(state);
  const themePresetIdToPreview = getThemePresetIdToPreview(state);
  return isPresetPanelOpen ? themePresetIdToPreview : activeThemePresetId;
};
export const getSelectedThemePresetType = state => {
  var _getPresetById;
  const selectedThemePresetId = getSelectedThemePresetId(state);
  return selectedThemePresetId !== undefined ? (_getPresetById = getPresetById(state, selectedThemePresetId)) === null || _getPresetById === void 0 ? void 0 : _getPresetById.type : PRESET_TYPES.EMPTY;
};

// Use createSelector to memoize getting presets list rather than creating a new reference
// which allows presets to be used in dependency array without triggering change on every render
export const getPresets = createSelector([getPresetsById], presetsById => Object.values(presetsById));
export const getActiveThemePreset = state => {
  const activeThemePresetId = getActiveThemePresetId(state);
  return activeThemePresetId !== undefined ? getPresetById(state, activeThemePresetId) : undefined;
};
export const getActiveThemePresetType = state => {
  const activeThemePreset = getActiveThemePreset(state);
  return (activeThemePreset === null || activeThemePreset === void 0 ? void 0 : activeThemePreset.type) || PRESET_TYPES.EMPTY;
};
export const getActiveThemePresetStyles = state => {
  const activeThemePreset = getActiveThemePreset(state);
  return activeThemePreset === null || activeThemePreset === void 0 ? void 0 : activeThemePreset.styles;
};
export const getIgnoreUserThemeOverrides = state => {
  var _state$presets2;
  return (_state$presets2 = state.presets) === null || _state$presets2 === void 0 ? void 0 : _state$presets2.ignoreUserThemeOverrides;
};
export const getActiveThemePresetObjectId = state => {
  var _state$presets3;
  return (_state$presets3 = state.presets) === null || _state$presets3 === void 0 ? void 0 : _state$presets3.activeThemePresetObjectId;
};
export const getHasLoadedPresets = state => getPresetsRequestStatus(state) === RequestStatusTypes.SUCCEEDED && getFetchActiveThemePresetBufferRequestStatus(state) === RequestStatusTypes.SUCCEEDED;
export const getIsLoadingPresets = state => getPresetsRequestStatus(state) === RequestStatusTypes.PENDING || getFetchActiveThemePresetBufferRequestStatus(state) === RequestStatusTypes.PENDING;
export const getPublishedActiveThemePresetId = state => {
  var _state$presets4;
  return (_state$presets4 = state.presets) === null || _state$presets4 === void 0 ? void 0 : _state$presets4.publishedActiveThemePresetId;
};